import {
  Cctv, Network, Fingerprint, PhoneCall, Stethoscope, Code2, Computer, UserCheck,
  Landmark, Building2, ShoppingCart, HeartPulse, GraduationCap, Hotel, Factory,
  ShieldCheck, Clock, Award, MapPin, Presentation,
} from "lucide-react";

export const ICONS = {
  Cctv, Network, Fingerprint, PhoneCall, Stethoscope, Code2, Computer, UserCheck,
  Landmark, Building2, ShoppingCart, HeartPulse, GraduationCap, Hotel, Factory,
  ShieldCheck, Clock, Award, MapPin, Presentation,
};

export const Icon = ({ name, className }) => {
  const Cmp = ICONS[name] || ShieldCheck;
  return <Cmp className={className} />;
};
